import { twJoin } from 'tailwind-merge';

import { Skeleton } from '@/_components';

export function Loading({ className }: { className?: string }) {
  return (
    <article className={twJoin('@container flex h-full flex-col justify-start gap-6', className)}>
      <section className="flex flex-row flex-wrap items-center justify-between gap-2">
        <div>
          <Skeleton className="h-8 w-40 rounded-xl" />
        </div>

        <div>
          <Skeleton className="h-6 w-32 rounded-xl" />
        </div>
      </section>

      <div className="flex h-[250px] w-full flex-col items-center">
        <Skeleton className="w-full flex-1 rounded-xl" />
      </div>
    </article>
  );
}
